var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "vuestic-tabs" },
    [
      _c("div", [
        _c(
          "nav",
          { staticClass: "nav nav-pills va-row" },
          _vm._l(_vm.names, function (name) {
            return _c(
              "div",
              {
                key: name,
                staticClass: "nav-item col",
                class: { active: name === _vm.currentActive },
                on: {
                  click: function ($event) {
                    return _vm.setActive(name)
                  },
                },
              },
              [
                _c("span", { staticClass: "nav-link" }, [
                  _c("h5", [_vm._v(_vm._s(name))]),
                ]),
              ]
            )
          }),
          0
        ),
        _c("div", { staticClass: "track" }, [
          _c("div", { class: _vm.underscoreClass }),
        ]),
      ]),
      _c("vuestic-simple-select", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: false,
            expression: "false",
          },
        ],
        staticClass: "simple-select",
        attrs: { options: _vm.names },
        model: {
          value: _vm.currentActive,
          callback: function ($$v) {
            _vm.currentActive = $$v
          },
          expression: "currentActive",
        },
      }),
      _c(
        "div",
        { staticClass: "tab-content" },
        _vm._l(_vm.names, function (name) {
          return _c(
            "div",
            {
              key: name,
              staticClass: "tab-pane",
              class: { active: name === _vm.currentActive },
            },
            [_vm._t(name)],
            2
          )
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }